module.exports = __webpack_public_path__ + "img/kings_logo.cfb050d9.jpg";